class Barcode {
  constructor(data, options) {
    this.data = data;
    this.text = options.text || data;
    this.options = options;
  }
}
var stdin_default = Barcode;
export {
  stdin_default as default
};
